module.exports = __webpack_public_path__ + "images/free-trial/thumbs-up.7a2986bddd638ea60fca.svg";